module.exports = __webpack_public_path__ + "static/home-vid-90f304c5c7d118070ef861aae6f35e24.mp4";